var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2105 3.15789H11.0526V1.57895C11.0526 0.702632 10.35 0 9.47368 0H6.31579C5.43947 0 4.73684 0.702632 4.73684 1.57895V3.15789H1.57895C0.702632 3.15789 0.00789473 3.86053 0.00789473 4.73684L0 13.4211C0 14.2974 0.702632 15 1.57895 15H14.2105C15.0868 15 15.7895 14.2974 15.7895 13.4211V4.73684C15.7895 3.86053 15.0868 3.15789 14.2105 3.15789ZM9.47368 3.15789H6.31579V1.57895H9.47368V3.15789Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.188ffc6214995d71348b6ed85f3031a5.svg";
export { ForwardRef as ReactComponent };